<div id="primary-nav" style="display: flex; flex:1; justify-content: flex-end; gap: 10px; padding-right: 24px;">
  <!-- @for (item of this.getMenuItems(); track trackById(item)) {
    <div style="padding:0px 15px;">
      <a href="#" [ngClass]="item.path == selectedId ? 'selected' : ''" [routerLink]="item.path" (click)="setSelectedNavItem(item.path)">{{ item.title }}</a>
    </div>
  } -->
</div>
